import React,{useEffect, useState} from 'react'
import styled from 'styled-components';
import { Notification } from 'iconsax-react';


const NotificationWrapper = styled.div`
    display: flex;
    justify-content: center;
    border-radius: 50%;
    padding: 3px;
    margin-left: 10px;
    cursor: pointer;
    border: 2px #595959 solid;
    width: 50px;
    height: 50px;
    padding: 10px;
    position: relative;

    &:hover{
      border-color:#40a9ff;
      color: #40a9ff;
      background-color: rgba(64,169,255,0.3125) ;
    }

    &:hover > div > svg > g > g > path {
      fill: #40a9ff;
    }

    &:hover >  svg > path {
      fill:#40a9ff;
    }

    @media screen and (max-width:950px){
      padding:5px;
      margin: 0px 0px 0px 15px;
    }

`
export const  NotificationStatus = styled.div`
    width:15px;
    height:15px;
    background-color:${(props) => props.color};
    border-radius:50%;
    position: absolute;
    top:0;
    right:0;
    border:none;
`

const NotificationIcon = ({status}) => {
  const [statusColor, setStatusColor] = useState();

  const NotificationColor = () => {
    if(status === 'on'){
      setStatusColor('#f5222d')
   } else{
    setStatusColor('#595959')
   }
  }

  console.log(statusColor);

  useEffect(() => {
    NotificationColor()
  })


  return (
    <>
    <NotificationWrapper>

    <NotificationStatus color={statusColor}></NotificationStatus>
    <Notification size="24" color="white" variant="Bold"/>

    </NotificationWrapper>
    </>
  )
}

export default NotificationIcon